function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#87BBFD",
  d: "M12 24a12 12 0 100-24 12 12 0 000 24"
}), React.createElement("path", {
  fill: "#556CD6",
  d: "M11 22A11 11 0 00.04 11c-.02.33-.04.66-.04 1a12 12 0 0012 12v-1a1 1 0 01-1-1"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M11.34 3.52a14.98 14.98 0 00-5.19 9.36A10.99 10.99 0 0111 22a1 1 0 001 1V3.28c-.23 0-.47.08-.66.24"
}), React.createElement("path", {
  fill: "#556CD6",
  d: "M12.66 3.52a14.98 14.98 0 015.19 9.36A10.99 10.99 0 0013 22a1 1 0 01-1 1V3.28c.23 0 .47.08.66.24"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M22.02 11.18A11 11 0 0013 22a1 1 0 01-1 1c.35 0 .7-.02 1.04-.06v.01l.15-.02.7-.1.29-.05.86-.2A11 11 0 0023 12a.83.83 0 00-.98-.82"
}))));